import { NavLink } from 'react-router-dom';

import { haptic } from '@/lib/telegram';
import { cls } from '@/lib/format';

const tabs = [
  { to: '/', label: 'Home', emoji: '🏠', end: true },
  { to: '/assignments', label: 'Tasks', emoji: '📋' },
  { to: '/learn', label: 'Learn', emoji: '📚' },
  { to: '/history', label: 'History', emoji: '📅' },
  { to: '/stats', label: 'Stats', emoji: '📊' },
  { to: '/profile', label: 'Profile', emoji: '👤' },
];

export function BottomTabBar() {
  return (
    <nav
      className="fixed inset-x-0 z-20 border-t border-[var(--color-separator)] bg-[var(--color-secondary-bg)]"
      style={{ bottom: 0, paddingBottom: 'var(--safe-bottom, 0px)' }}
    >
      <div className="mx-auto flex max-w-lg items-stretch">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            onClick={() => haptic('selection')}
            className={({ isActive }) =>
              cls(
                'flex flex-1 flex-col items-center gap-1 py-2 text-xs transition-opacity',
                isActive
                  ? 'text-[var(--color-accent)] opacity-100'
                  : 'text-[var(--color-muted)] opacity-80',
              )
            }
          >
            <span className="text-lg leading-none">{tab.emoji}</span>
            <span>{tab.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
